import React from 'react';
import Layout from './components/Layout/Layout';
import Booking from './containers/Booking/Booking';
import ErrorBoundary from './containers/ErrorBoundary/ErrorBoundary';

function App(props) {
  return (
    <div className="App" id="trumpauto-booking-app-container">
      <Layout>
        <ErrorBoundary>
          <Booking APIKey={props.APIKey}></Booking>
        </ErrorBoundary>
      </Layout>
    </div>
  );
}

export default App;
